export const NEW_BACKOFFICE_URL = "https://admin-vel.masalledesport.com";
